import {MessageHistoryMessage} from "./messageHistoryMessage";

export class MessageHistory {
    private messages: MessageHistoryMessage[] = [];

    public addMessage(message: MessageHistoryMessage): void {
        this.messages.push(message);
    }

    public getMessages():MessageHistoryMessage[] {
        return this.messages;
    }

    public count(): number {
        return this.messages.length;
    }
}